import { render, staticRenderFns } from "./DoneTask.vue?vue&type=template&id=5b12056f&"
import script from "./DoneTask.vue?vue&type=script&lang=js&"
export * from "./DoneTask.vue?vue&type=script&lang=js&"
import style0 from "./DoneTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports